var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list_9dz8e9dwd7n1 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2143 0H2.7085V25H22.2918V6.0775L16.2143 0ZM16.4585 1.4225L20.8693 5.83333H16.4585V1.4225ZM3.54183 24.1667V0.833333H15.6252V6.66667H21.4585V24.1667H3.54183Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7083 8.75H11.0417C10.8117 8.75 10.625 8.93625 10.625 9.16667C10.625 9.39708 10.8117 9.58333 11.0417 9.58333H17.7083C17.9383 9.58333 18.125 9.39708 18.125 9.16667C18.125 8.93625 17.9383 8.75 17.7083 8.75Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.53152 7.59126L7.73943 9.02501L7.16985 8.45543C7.00693 8.29251 6.7436 8.29251 6.58068 8.45543C6.41777 8.61834 6.41777 8.88168 6.58068 9.04459L7.41402 9.87793C7.49485 9.95876 7.60152 10 7.7086 10C7.80027 10 7.89235 9.97001 7.9686 9.90876L10.0519 8.24209C10.2319 8.09793 10.2607 7.83584 10.1169 7.65626C9.9736 7.47626 9.7111 7.44751 9.53152 7.59126Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.7083 13.3333H11.0417C10.8117 13.3333 10.625 13.5196 10.625 13.75C10.625 13.9804 10.8117 14.1666 11.0417 14.1666H17.7083C17.9383 14.1666 18.125 13.9804 18.125 13.75C18.125 13.5196 17.9383 13.3333 17.7083 13.3333Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.53152 12.1746L7.73943 13.6083L7.16985 13.0387C7.00693 12.8758 6.7436 12.8758 6.58068 13.0387C6.41777 13.2017 6.41777 13.465 6.58068 13.6279L7.41402 14.4612C7.49485 14.5421 7.60152 14.5833 7.7086 14.5833C7.80027 14.5833 7.89235 14.5533 7.9686 14.4921L10.0519 12.8254C10.2319 12.6812 10.2607 12.4192 10.1169 12.2396C9.9736 12.0596 9.7111 12.0308 9.53152 12.1746Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.7083 17.9167H11.0417C10.8117 17.9167 10.625 18.1029 10.625 18.3334C10.625 18.5638 10.8117 18.75 11.0417 18.75H17.7083C17.9383 18.75 18.125 18.5638 18.125 18.3334C18.125 18.1029 17.9383 17.9167 17.7083 17.9167Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.53152 16.7579L7.73943 18.1917L7.16985 17.6221C7.00693 17.4592 6.7436 17.4592 6.58068 17.6221C6.41777 17.785 6.41777 18.0484 6.58068 18.2113L7.41402 19.0446C7.49485 19.1254 7.60152 19.1667 7.7086 19.1667C7.80027 19.1667 7.89235 19.1367 7.9686 19.0754L10.0519 17.4088C10.2319 17.2646 10.2607 17.0025 10.1169 16.8229C9.9736 16.6429 9.7111 16.6142 9.53152 16.7579Z",
    fill: "#5F6C72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgram);
export default __webpack_public_path__ + "static/media/icon-program.2e62521a79465d21745236863ff4648c.svg";
export { ForwardRef as ReactComponent };